
import { Component, Vue } from "vue-property-decorator"

export interface NavbarOption {
    icon?: string
    title?: any
    action?: Function
    to?: string
}

@Component({})
export default class NavbarOptions extends Vue {
    private options: NavbarOption[] = []

    get optionsWithIcons() {
        return this.options.filter((o) => o.icon)
    }

    get optionsWithoutIcons() {
        return this.options.filter((o) => !o.icon)
    }

    mounted() {
        console.log("navbar options yo")
        navbar = this
    }

    public setOptions(options: NavbarOption[]) {
        this.options = options
    }

    public clearOptions() {
        this.options = []
    }
}

let navbar: NavbarOptions | undefined = undefined
export { navbar }
